import styles from './DeviceBatteryIcon.module.scss';
import { Icon, Tooltip } from '@mui/material';
import { DeviceLastReading } from 'types';
import {
    BatteryUnknown,
    Battery20,
    Battery60,
    BatteryFull,
} from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { getBatteryLevel } from 'helpers/general';
import { isDeviceGen5 } from 'helpers/device';

export interface DeviceBatteryIconProps {
    battery?: Pick<DeviceLastReading, 'battery_crit' | 'battery_warn'> | null;
    itemNumber: string;
}

const DeviceBatteryIcon = ({ battery, itemNumber }: DeviceBatteryIconProps) => {
    const [color, setColor] = useState('#55A05C');
    const [icon, setIcon] = useState(
        <BatteryUnknown data-testid="BatteryUnknown"></BatteryUnknown>
    );

    useEffect(() => {
        if (battery) {
            let batteryLevel = getBatteryLevel(
                battery.battery_crit,
                battery.battery_warn
            );

            // Override for G5 devices while battery equations are developed
            if (isDeviceGen5(itemNumber)) {
                batteryLevel = 100;
            }

            if (batteryLevel === 20) {
                setIcon(<Battery20 data-testid="Battery20" />);
                setColor('#EC4E27');
            } else if (batteryLevel === 60) {
                setIcon(<Battery60 data-testid="Battery60" />);
                setColor('#F19436');
            } else if (batteryLevel === 100) {
                setIcon(<BatteryFull data-testid="BatteryFull" />);
                setColor('#55A05C');
            }
        }
    }, [battery, itemNumber]);

    return (
        <div
            className={styles.DeviceBatteryIcon}
            data-testid="DeviceBatteryIcon"
        >
            <Tooltip title={'Battery'}>
                <Icon sx={{ color: color }}>{icon}</Icon>
            </Tooltip>
        </div>
    );
};

export default DeviceBatteryIcon;
